import getMailboxJunkEmailConfigurationOperation from 'owa-service/lib/operation/getMailboxJunkEmailConfigurationOperation';
export default function loadMailboxJunkEmailConfiguration() {
    return getMailboxJunkEmailConfigurationOperation().then(function (responseMessage) {
        if (responseMessage.WasSuccessful) {
            return responseMessage.Options;
        }
        else {
            throw new Error("getMailboxJunkEmailConfigurationOperation " + responseMessage.ErrorCode + " " + responseMessage.ErrorMessage);
        }
    });
}
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map